import React from "react";
import type {
  TypeChartLegendTheme,
  TypeLegendLabels,
} from "./ChartLegendTypes";
import { useTheme } from "styled-components";
import { Label, Swatch } from "./styles";
import { Text } from "@sproutsocial/seeds-react-text";
import { getChartLegendSwatchColor } from "./chartLegendTheme";

export const useChartLabels = (
  legendLabels: TypeLegendLabels[],
  theme: TypeChartLegendTheme
) => {
  const racineTheme = useTheme();
  const colors = racineTheme.colors;

  return legendLabels.map((label, i) => {
    const labelColor = label.color
      ? label.color
      : getChartLegendSwatchColor(theme, i, colors);

    return (
      <Label key={`chart-legend-label-${i}`}>
        <Swatch bg={labelColor} data-qa-swatch="" />
        <Text as="div" fontSize={200} breakWord>
          {label.name}
        </Text>
      </Label>
    );
  });
};
